export const navClassname = 'nav';
export const pillsClassname = `${navClassname}-pills`;
export const tabsClassname = `${navClassname}-tabs`;
export const fillClassname = `${navClassname}-fill`;
export const itemClassname = `${navClassname}-item`;
export const linkClassname = `${navClassname}-link`;

export const fillStyles = {
  flex: '1 1 auto',
  textAlign: 'center',
} as const;
